import { Box, styled } from '@mui/material'
import { FieldProps, useRecordContext } from 'react-admin'

const MainContent = styled(Box)((/* { theme } */) => ({
  // add some style for HTMl content later..
}))

export const PromotionContent: React.FC<FieldProps> = ({ source }) => {
  const record = useRecordContext()
  return source ? <MainContent dangerouslySetInnerHTML={{ __html: record[source] }} /> : null
}
